<template>
    <div>
        <!-- {{dayTask}} -->
        <div class="task-detail-card">
            <div class="d-flex align-items-center justify-content-between">
                <div class="">
                    <!-- <div class="row"> -->
                    <div class="d-flex">
                        <img
                            src="../assets/image/check.png"
                            alt="checkbox"
                            width="20"
                            height="20"
                            :class="[
                                dayTask.status ? 'check-logo-completed' : 'check-logo-incompleted',
                                'ms-auto d-block',
                            ]"
                        />
                        <p class="task-detail-title ms-2">
                            {{ dayTask.task.title }}
                            <Badge
                                :label="dayTask.completedDate < dayTask.endDate ? 'Finished On Time' : 'Over Due'"
                                v-if="dayTask.status"
                                :class="[
                                    'badge-neon',
                                    'ms-2',
                                    dayTask.completedDate < dayTask.endDate
                                        ? 'badge-neon-success-outline'
                                        : 'badge-neon-error-outline',
                                ]"
                            />
                        </p>
                    </div>

                    <!-- </div> -->
                </div>
            </div>
            <p class="task-detail-subtitle my-0 mt-2"><b v-if="dayTask.task.submissionType === 'LINK'">Submitted Link: </b><a
                class="task--subtitle mt-2"
                :href="dayTask.link"
                v-if="dayTask.task.submissionType === 'LINK'"
                target="_blank"
                >{{ dayTask.link }}</a
            ></p>
            <p class="task-detail-subtitle mt-2" v-if="dayTask.task.submissionType === 'LINK'">
                <b>Submission Count: </b> {{dayTask.submissionCount}}
            </p>
            <p class="task-detail-subtitle mt-2" v-if="dayTask.status">
                <b>Completed Date:</b> {{ formatDate(dayTask.completedDate) }}
            </p>
            <p class="task-detail-subtitle mt-2"><b>Due Date:</b> {{ formatDate(dayTask.endDate) }}</p>
            <p class="task-detail-subtitle mt-2" v-if="dayTask.taskStatus === 'COMPLETED' && dayTask.task.submissionType === 'LINK'"><b>Score:</b>  {{dayTask.score}} / 10</p>
            <p class="task-detail-subtitle mt-2" v-if="dayTask.taskStatus === 'COMPLETED' && dayTask.task.submissionType === 'SUBMIT'"><b>Submission Type:</b>  Submit </p>
            <div
                class="d-flex gap-2"
                v-if="dayTask.task.submissionType === 'LINK' && !showScoreBox && !showComment && dayTask.taskStatus == 'IN_REVIEW'"
            >
                <Button label="Approve" class="qb-btn qb-btn-black-sm my-2" @onClick="approved()" />
                <Button label="Re-Assign" class="qb-btn qb-btn-outline-sm my-2" @onClick="rejected()" />
            </div>
            <div v-else>
                <Badge
                    :label="dayTask.taskStatus.replaceAll('_',' ')"
                    :class="[
                        dayTask.taskStatus === 'REVERTED' ? 'badge-neon badge-neon-error-outline' : '',
                        dayTask.taskStatus === 'IN_REVIEW' ? 'badge-neon badge-neon-warning-outline' : '',
                        dayTask.taskStatus === 'COMPLETED' ? 'badge-neon badge-neon-success-outline' : '',
                        dayTask.taskStatus === 'NOT_YET_STARTED' ? 'badge-neon badge-neon-grey-outline' : '',
                    ]"
                />
            </div>

            <div v-if="showScoreBox">
                <div class="d-flex flex-column">
                    <p class="my-1 task-detail-title">Score</p>
                    <input type="number" min="0" max="10" v-model="score" class="form--control" />
                    <p class="my-1 task-detail-title">Comment on Score</p>
                    <TextArea type="text" v-model="comment" />
                </div>
                <div class="d-flex justify-content-end">
                    <Button label="Save" class="qb-btn qb-btn-primary-sm" @onClick="saveScore(dayTask)" />
                </div>
            </div>
            <div v-if="showComment">
                <div class="d-flex flex-column">
                    <p class="my-1 task-detail-title">Comment on Re-Assign</p>
                    <TextArea type="text" v-model="reassigncomment" />
                </div>
                <div class="d-flex justify-content-end">
                    <Button label="Save" class="qb-btn qb-btn-primary-sm" @onClick="reassign(dayTask)" />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from 'vue';
import Button from '../components/ButtonComponent.vue';
import Badge from '../components/BadgeComponent.vue';
// import Input from "../components/TextFieldComponent.vue"
import TextArea from '../components/TextAreaComponent.vue';
import { createNamespacedHelpers } from 'vuex';
const { mapGetters: userMapGetters } = createNamespacedHelpers('Auth');
const { mapActions: mapUserActions } = createNamespacedHelpers('User');
const { mapGetters, mapActions: workSheetMapActions } = createNamespacedHelpers('WorkSheet');
const { mapGetters:trainingMapGetters ,mapActions:trainingMapActions} = createNamespacedHelpers('Training');
export default {
    name: 'TaskProgressListComponent',
    data() {
        return {
            showScoreBox: false,
            score: 0,
            comment: '',
            reassigncomment: '',
            showComment: false,
        };
    },
    props: {
        index: {
            type: Number,
        },
        dayTask: {
            type: Object,
        },
        lastIndex: {
            type: Number,
        },
        day: {
            type: Object,
        },
    },
    components: {
        Button,
        Badge,
        // Input,
        TextArea,
    },
    computed: {
        ...userMapGetters({
            user: 'getUser',
        }),
        ...mapGetters({
            worksheet: 'getWorkSheet',
        }),
         ...trainingMapGetters({
            commentsForSelectedWorksheet: "getCommentsForSelectedWorkSheet",
        }),
    },
    methods: {
        ...mapUserActions({
            updateTaskCompletion: 'UPDATE_TASK_STATUS',
        }),
        ...workSheetMapActions({
            getWorkSheetDetails: 'GET_WORKSHEET_BY_ID_BY_ADMIN',
        }),
         ...trainingMapActions({
      getCommentsByWorksheetId: "GET_COMMENTS_BY_WORKSHEET_ID",
    }),
        showTaskPage(id) {
            this.$router.push({
                name: 'ModuleDayDetailPage',
                params: { dayId: id },
            });
        },
        edit() {
            this.$emit('onEdit', this.dayTask);
        },
        deletemodal(dayTask) {
            this.$emit('showDelete', dayTask);
        },
        approved() {
            this.showScoreBox = true;
        },
        rejected() {
            this.showComment = true;
        },
        reassign(dayTask) {
            let payload = {
                userId: this.user.userId,
                status: false,
                id: this.worksheet.id,
                userType: 'A',
                taskId: dayTask.task.id,
                day: this.day.day,
                comment: this.reassigncomment,
            };
            console.log(payload);
            if(this.reassigncomment){
            this.updateTaskCompletion({
                taskData: payload,
                successcallback: ({ data }) => {
                    if (data.status === 'OK') {
                        Vue.$toast.success('Task Updated successfully');
                        this.showComment = false;
                        this.getWorkSheetDetails({ id: this.worksheet.id, userId: this.user.userId });
                        this.getCommentsByWorksheetId(this.worksheet.id)
                    } else {
                        Vue.$toast.error('Task Updation Failed');
                    }
                },
                errorcallback: (err) => {
                    Vue.$toast.error(err.message);
                },
            });
            } else {
                Vue.$toast.error("Enter Comments")
            }
        },
        saveScore(dayTask) {
            console.log(this.day);
            let payload = {
                score: this.score,
                comment: this.comment,
                userId: this.user.userId,
                status: true,
                id: this.worksheet.id,
                userType: 'A',
                taskId: dayTask.task.id,
                day: this.day.day,
            };
            console.log(payload);
            if(this.score>0 && this.score<=10 && this.comment){
            this.updateTaskCompletion({
                taskData: payload,
                successcallback: ({ data }) => {
                    if (data.status === 'OK') {
                        Vue.$toast.success('Task Completed successfully');
                        this.showScoreBox = false;
                        this.getWorkSheetDetails({ id: this.worksheet.id, userId: this.user.userId });
                        this.getCommentsByWorksheetId(this.worksheet.id)
                    } else {
                        Vue.$toast.error('Task Updation Failed');
                    }
                },
                errorcallback: (err) => {
                    Vue.$toast.error(err.message);
                },
            });
            } else {
                if(!this.comment.length>0){
                    Vue.$toast.error("Enter comments")
                } if(this.score<0){
                    Vue.$toast.error("Score cannot be negative")
                } if(this.score>10){
                    Vue.$toast.error("Score cannot be greater than 10")
                } if(this.score==0) {
                    Vue.$toast.error("Score cannot be 0")
                } 
            }
        },
    },
};
</script>
<style lang="scss" scoped>
@import '../assets/scss/color.scss';
@import '../assets/scss/font.scss';
@import '../assets/scss/field.scss';
.card-box {
    background-color: $light-100;
    padding: 10px 15px;
    margin-left: 20px;
    border-radius: $field-border-radius;
}

.icon--arrow--right {
    cursor: pointer;
}

.task--title {
    font-weight: 600;
    font-size: 14px;
    margin: 0px;
    margin-bottom: 5px;
}

.fa-circle-check {
    color: $dark-200;
    margin-right: 5px;
    background-color: $light-100;
}

.task--description {
    font-size: 14px;
}

.task-detail-card {
    background-color: $white;
    padding: 8px 12px;
    border-radius: $field-border-radius;
    margin-bottom: 10px;
    margin-left: 20px;
    border: 1px solid $light-200;
    box-shadow: rgba(0, 0, 0, 0.05) 0px 1px 2px 0px;

    &:hover {
        background-color: #fdfdfd;
    }
}

.timeline-box {
    border-left: 1px solid $dark-200;
    padding-left: 10px;
    margin-left: 10px;
}

.task-timeline-title {
    font-size: $font-size-md;
    margin: 0px;
    margin-left: -17px;
}

.task-detail-title {
    font-size: $font-size-md;
    font-weight: $font-weight-bold;
    color: $dark-400;
    margin-bottom: 0px;
}

.task-detail-subtitle {
    font-size: $font-size-sm;
    color: $light-600;
    font-weight: $font-weight-normal-1;
    margin-bottom: 0px;
}

.day--title {
    font-weight: 500;
    margin: 0px;
}

.check-logo-completed {
    filter: grayscale(0%);
    opacity: 100%;
}

.check-logo-incompleted {
    filter: grayscale(100%);
    opacity: 30%;
}

.task--subtitle {
    font-size: $font-size-md;
    margin: 0px;
    margin-bottom: 5px;
}

.label-text {
    color: black;
    font-size: $font-size-md;
}
.form--control {
    border: 1px solid rgb(222, 222, 222);
    border-radius: $field-border-radius;
    padding: 6px 10px;
    width: 60px;
}

.form--control::placeholder {
    font-size: 15px;
}

.form--control:focus {
    outline: none;
}
</style>
